import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { ILoginOtpStep1Response } from '../../../entity/interface/iLoginEntities';

export interface ILoginOtpStep1UseCase {
    execute(language: string, username: string, agent: string): Promise<ILoginOtpStep1Response>;
}

export class LoginOtpStep1UseCase implements ILoginOtpStep1UseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(language: string, username: string, agent: string): Promise<ILoginOtpStep1Response> {
        return await this.userRepo.loginOtpStep1(language, username, agent);
    }
}
